import React from 'react'
import PropTypes from 'prop-types'
import { InputGroup } from '@blueprintjs/core/lib/cjs/components/forms/inputGroup'
import { MenuItem } from '@blueprintjs/core/lib/cjs/components/menu/menuItem'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlass'
import ButtonSelect from 'src/components/ButtonSelect'
import {
    FILTER_ANY_LABEL,
    FILTER_FIELDS,
    TEMPLATE_TYPE_FILTER_KEY,
    getTemplateTypeLabel,
} from 'src/routes/Runbooks/RunbooksTemplates/utils'
import styles from './runbooksTemplatesFilters.module.scss'

/**
 * Filter/search bar for RunbooksTemplates table.
 * @param {object} props
 * @param {object} props.filterOptions
 * @param {object} props.filters
 * @param {string} props.searchQuery
 * @param {string} props.anyValue
 * @param {function} props.onFilterChange
 * @param {function} props.onSearchChange
 */
const RunbooksTemplatesFilters = ({
    filterOptions,
    filters,
    searchQuery,
    anyValue,
    onFilterChange,
    onSearchChange,
}) => {
    const buildItems = (key) => {
        return (filterOptions[key] || []).map((option) => {
            const value =
                option && typeof option === 'object' ? option.value : option
            const isObjectOption = option && typeof option === 'object'
            const isAnyValue = value === anyValue
            let label = value

            if (isObjectOption) {
                label = option.label
            } else if (isAnyValue) {
                label = FILTER_ANY_LABEL
            }
            // Apply display mapping for template type
            if (key === TEMPLATE_TYPE_FILTER_KEY && value !== anyValue) {
                label = getTemplateTypeLabel(value)
            }
            return {
                value,
                label,
                selected: filters[key] === value,
            }
        })
    }

    return (
        <div className={styles.headerWrapper}>
            <div className={styles.filtersWrapper}>
                <div className={styles.filtersGroup}>
                    {FILTER_FIELDS.map((field) => {
                        const items = buildItems(field.key)
                        const selectedItem =
                            items.find((item) => item.selected) || items[0]

                        return (
                            <ButtonSelect
                                key={field.key}
                                label={field.label}
                                icon={field.icon}
                                items={items}
                                itemRenderer={(item) => (
                                    <MenuItem
                                        intent="none"
                                        active={item.selected}
                                        key={item.value}
                                        text={item.label}
                                        onClick={() =>
                                            onFilterChange(
                                                field.key,
                                                item.value
                                            )
                                        }
                                    />
                                )}
                                selectedLabel={
                                    selectedItem?.label || FILTER_ANY_LABEL
                                }
                            />
                        )
                    })}
                </div>

                <InputGroup
                    className={styles.searchInput}
                    placeholder="Search by template name"
                    value={searchQuery}
                    onChange={onSearchChange}
                    leftElement={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                />
            </div>
        </div>
    )
}

RunbooksTemplatesFilters.propTypes = {
    anyValue: PropTypes.string.isRequired,
    filterOptions: PropTypes.shape({
        templateType: PropTypes.array,
        organization: PropTypes.array,
        runbookCategory: PropTypes.array,
        deviceType: PropTypes.array,
    }).isRequired,
    filters: PropTypes.shape({
        templateType: PropTypes.string,
        organization: PropTypes.string,
        runbookCategory: PropTypes.string,
        deviceType: PropTypes.string,
    }).isRequired,
    onFilterChange: PropTypes.func.isRequired,
    onSearchChange: PropTypes.func.isRequired,
    searchQuery: PropTypes.string.isRequired,
}

export default RunbooksTemplatesFilters
